import React from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import { JobsTable } from '../jobs/JobsTable';
import { ParserTab } from './components/ParserTab';
import { TasksTab } from './components/TasksTab';
import { InventorySyncTab } from './components/InventorySyncTab';
import { useLocation, useNavigate } from 'react-router-dom';

export function System() {
    const navigate = useNavigate();
    const location = useLocation();

    const getTabFromHash = (hash: string) => {
        const normalized = (hash || '').replace('#', '').replace(/-/g, '').toLowerCase();
        if (normalized === 'parser' || normalized === 'парсер') return 1;
        if (normalized === 'inventorysync' || normalized === 'sync' || normalized === 'инвентарь' || normalized === 'синк') return 2;
        return 0; // default to tasks
    };

    const getHashFromTab = (value: number) => {
        if (value === 1) return '#parser';
        if (value === 2) return '#inventory-sync';
        return '#tasks';
    };

    const [activeTab, setActiveTab] = React.useState<number>(getTabFromHash(location.hash));

    React.useEffect(() => {
        const next = getTabFromHash(location.hash);
        if (next !== activeTab) {
            setActiveTab(next);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.hash]);

    const handleTabChange = (event: React.SyntheticEvent | null, newValue: number | string | null) => {
        const numericValue = typeof newValue === 'number' ? newValue : 0;
        setActiveTab(numericValue);
        const newHash = getHashFromTab(numericValue);
        if (location.hash !== newHash) {
            navigate({ pathname: location.pathname, search: location.search, hash: newHash });
        }
    };

    return (
        <>
        <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
            <Box
                component="main"
                className="MainContent"
                sx={{
                    px: { xs: 2, md: 6 },
                    pt: {
                        xs: 'calc(12px + var(--Header-height))',
                        sm: 'calc(12px + var(--Header-height))',
                        md: 3,
                    },
                    pb: { xs: 2, sm: 2, md: 3 },
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minWidth: 0,
                    height: '100dvh',
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        mb: 1,
                        gap: 1,
                        flexDirection: { xs: 'row', sm: 'row' },
                        alignItems: { xs: 'center', sm: 'center' },
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography level="h2" component="h1">
                        Система
                    </Typography>
                </Box>

                <Tabs value={activeTab} onChange={handleTabChange} sx={{bgcolor: 'transparent', flex: 1, display: 'flex', flexDirection: 'column'}}>
                    <TabList
                        tabFlex={1}
                        size="sm"
                        sx={{
                            pl: { xs: 0, md: 4 },
                            justifyContent: 'left',
                            overflowX: { xs: 'auto', md: 'visible' },
                            flexWrap: { xs: 'nowrap', md: 'wrap' },
                            [`&& .${tabClasses.root}`]: {
                                fontWeight: '600',
                                flex: 'initial',
                                color: 'text.tertiary',
                                [`&.${tabClasses.selected}`]: {
                                    bgcolor: 'transparent',
                                    color: 'text.primary',
                                    '&::after': {
                                        height: '2px',
                                        bgcolor: 'primary.500',
                                    },
                                },
                            },
                        }}
                    >
                        <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={0}>
                            Задачи
                        </Tab>
                        <Tab sx={{borderRadius: '6px 6px 0 0'}} indicatorInset value={1}>
                            Парсер
                        </Tab>
                        <Tab sx={{ borderRadius: '6px 6px 0 0' }} indicatorInset value={2}>
                            <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>Синк</Box>
                            <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>Синк инвентарей</Box>
                        </Tab>
                    </TabList>

                    <TabPanel value={0} sx={{ flex: 1, overflow: 'auto' }}>
                        <TasksTab />
                    </TabPanel>

                    <TabPanel value={1} sx={{ flex: 1, overflow: 'auto' }}>
                        <ParserTab />
                    </TabPanel>

                    <TabPanel value={2} sx={{ flex: 1, overflow: 'auto' }}>
                        <InventorySyncTab />
                    </TabPanel>
                </Tabs>
            </Box>
        </Box>
        </>
    );
}

export default System;


